import { AppActions } from "../../action";
import { EXPORT_WORKITEM_LIST, SET_SELECTED_WITN, SET_QUICK_FILTERS, SET_NAVIGATION_STATE } from "../../action-type";

const initialState = {
  selectedWITN: "",
  exportWorkItemList: false,
  quickFilters: {},
  navigationState: false,
};

type actionsType = AppActions;

const workItemReducer = (state: any = initialState, action: actionsType): any => {
  switch (action.type) {
    case SET_SELECTED_WITN:
      return {
        ...state,
        selectedWITN: action.data || "",
      };
    case EXPORT_WORKITEM_LIST:
          return {
          ...state,
            exportWorkItemList: action.data
          }
    case SET_QUICK_FILTERS: {
      return {
        ...state,
        quickFilters: action.data
      }
    }
    case SET_NAVIGATION_STATE: {
      return {
        ...state,
        navigationState: action.data || false
      }
    }
    default:
      return state;
  }
};

export default workItemReducer;